import React, { createContext, useContext, useState, useCallback } from "react";

const DICT = {
    es: {
        "nav.ecosystem": "Ecosistema",
        "nav.features": "Funciones",
        "nav.faq": "Preguntas",
        "nav.contact": "Contacto",
        "nav.login": "Iniciar sesión",
        "cta.demo": "Solicitar demostración",
        "cta.features": "Ver funciones",
        "hero.badge": "Biometría · QR · POS · Wallet",
        "hero.title1": "Gestión inteligente de",
        "hero.title2": "cafeterías escolares",
        "hero.sub": "Tecnología biométrica, QR, POS, autoservicio, dispensadoras inteligentes y pagos digitales integrados en una sola plataforma.",
        "eco.title": "Un ecosistema completo",
        "eco.sub": "Todo lo que una cafetería escolar necesita, conectado y en tiempo real.",
        "contact.title": "Solicita una demostración",
        "contact.sub": "Déjanos tus datos y te mostramos cómo BIOFOOD transforma la cafetería de tu colegio.",
        "form.name": "Nombre",
        "form.school": "Colegio",
        "form.email": "Correo",
        "form.phone": "Teléfono",
        "form.students": "Número de estudiantes",
        "login.welcome": "Bienvenido a BIOFOOD",
        "login.subtitle": "Ingresa tus credenciales para continuar",
        "login.campus": "Sede",
        "login.campusPlaceholder": "Selecciona tu sede (opcional)",
        "login.user": "Usuario / Correo",
        "login.password": "Contraseña",
        "login.forgot": "¿Olvidaste tu contraseña?",
        "login.submit": "Iniciar sesión",
        "login.demoAccounts": "Cuentas de prueba (clic para usar)",
        "login.back": "Volver al inicio",
        "forgot.title": "¿Olvidaste tu contraseña?",
        "forgot.sub": "Ingresa tu correo para restablecerla.",
        "forgot.send": "Enviar enlace",
        "forgot.sentTitle": "Revisa tu correo",
        "forgot.sentBody": "Si el correo existe, enviamos un enlace para restablecer tu contraseña.",
        "common.back": "Volver",
        "common.cancel": "Cancelar",
        "common.continue": "Continuar",
        "common.logout": "Cerrar sesión",
        "common.ready": "Listo",
        "common.loading": "Cargando…",
        "portal.title": "Portal de padres",
        "portal.balance": "Saldo disponible",
        "portal.recharge": "RECARGAR SALDO",
        "portal.todaySpent": "Consumo hoy",
        "portal.dailyLimit": "Límite diario",
        "portal.used": "usado",
        "portal.restrictions": "Restricciones alimentarias",
        "portal.menu": "Menú del día",
        "portal.noMenu": "Sin menú publicado para hoy.",
        "portal.recent": "Últimas compras",
        "portal.noTxns": "Sin movimientos",
        "portal.noTxnsSub": "Las compras aparecerán aquí en tiempo real.",
        "pos.title": "Punto de venta",
        "pos.search": "Buscar producto…",
        "pos.cart": "Carrito",
        "pos.emptyCart": "Añade productos al carrito",
        "pos.total": "Total",
        "pos.charge": "Cobrar",
        "pos.newSale": "Nueva venta",
        "pos.identify": "Identificar estudiante",
        "pos.scanFinger": "Leer huella",
        "pos.scanQr": "Escanear QR",
        "pos.scanning": "Leyendo…",
        "pos.pickStudent": "Simular lectura — elige un estudiante",
        "pos.balance": "Saldo",
        "pos.limit": "Límite diario",
        "pos.confirmSale": "Confirmar venta",
        "pos.approved": "¡Venta aprobada!",
        "pos.declined": "Venta no autorizada",
        "pos.newBalance": "Nuevo saldo",
        "pos.all": "Todos",
        "pos.items": "productos",
        "kiosk.welcome": "Bienvenido",
        "kiosk.tap": "Toca para comenzar",
        "kiosk.identify": "Identifícate",
        "kiosk.identifySub": "Usa tu huella o código QR para continuar",
        "kiosk.choose": "Elige tus productos",
        "kiosk.confirm": "Confirma tu pedido",
        "kiosk.done": "¡Listo!",
        "kiosk.doneSub": "Disfruta tu comida",
        "kiosk.restart": "Reiniciando…",
        "kiosk.myCart": "Mi pedido",
        "kiosk.pay": "Confirmar y pagar",
        "kiosk.cancel": "Cancelar",
        "kiosk.selectCafeteria": "Selecciona la cafetería",
        "kiosk.startOver": "Comenzar de nuevo",
        "status.pending": "Pendiente", "status.confirmed": "Confirmado", "status.rejected": "Rechazado",
        "status.refunded": "Reembolsado", "status.online": "En línea", "status.offline": "Desconectado", "status.low_stock": "Stock crítico",
    },
    en: {
        "nav.ecosystem": "Ecosystem",
        "nav.features": "Features",
        "nav.faq": "FAQ",
        "nav.contact": "Contact",
        "nav.login": "Sign in",
        "cta.demo": "Request a demo",
        "cta.features": "See features",
        "hero.badge": "Biometrics · QR · POS · Wallet",
        "hero.title1": "Smart management for",
        "hero.title2": "school cafeterias",
        "hero.sub": "Biometric and QR technology, POS, self-service, smart dispensers and digital payments integrated in a single platform.",
        "eco.title": "A complete ecosystem",
        "eco.sub": "Everything a school cafeteria needs, connected and in real time.",
        "contact.title": "Request a demo",
        "contact.sub": "Leave your details and we'll show you how BIOFOOD transforms your school's cafeteria.",
        "form.name": "Name",
        "form.school": "School",
        "form.email": "Email",
        "form.phone": "Phone",
        "form.students": "Number of students",
        "login.welcome": "Welcome to BIOFOOD",
        "login.subtitle": "Enter your credentials to continue",
        "login.campus": "Campus",
        "login.campusPlaceholder": "Select your campus (optional)",
        "login.user": "Username / Email",
        "login.password": "Password",
        "login.forgot": "Forgot your password?",
        "login.submit": "Sign in",
        "login.demoAccounts": "Demo accounts (click to use)",
        "login.back": "Back to home",
        "forgot.title": "Forgot your password?",
        "forgot.sub": "Enter your email to reset it.",
        "forgot.send": "Send link",
        "forgot.sentTitle": "Check your email",
        "forgot.sentBody": "If the email exists, we sent a link to reset your password.",
        "common.back": "Back",
        "common.cancel": "Cancel",
        "common.continue": "Continue",
        "common.logout": "Sign out",
        "common.ready": "Done",
        "common.loading": "Loading…",
        "portal.title": "Parent portal",
        "portal.balance": "Available balance",
        "portal.recharge": "ADD FUNDS",
        "portal.todaySpent": "Spent today",
        "portal.dailyLimit": "Daily limit",
        "portal.used": "used",
        "portal.restrictions": "Dietary restrictions",
        "portal.menu": "Today's menu",
        "portal.noMenu": "No menu published for today.",
        "portal.recent": "Recent purchases",
        "portal.noTxns": "No activity",
        "portal.noTxnsSub": "Purchases will appear here in real time.",
        "pos.title": "Point of sale",
        "pos.search": "Search product…",
        "pos.cart": "Cart",
        "pos.emptyCart": "Add products to the cart",
        "pos.total": "Total",
        "pos.charge": "Charge",
        "pos.newSale": "New sale",
        "pos.identify": "Identify student",
        "pos.scanFinger": "Scan fingerprint",
        "pos.scanQr": "Scan QR",
        "pos.scanning": "Scanning…",
        "pos.pickStudent": "Simulate scan — pick a student",
        "pos.balance": "Balance",
        "pos.limit": "Daily limit",
        "pos.confirmSale": "Confirm sale",
        "pos.approved": "Sale approved!",
        "pos.declined": "Sale declined",
        "pos.newBalance": "New balance",
        "pos.all": "All",
        "pos.items": "items",
        "kiosk.welcome": "Welcome",
        "kiosk.tap": "Tap to start",
        "kiosk.identify": "Identify yourself",
        "kiosk.identifySub": "Use your fingerprint or QR code to continue",
        "kiosk.choose": "Choose your items",
        "kiosk.confirm": "Confirm your order",
        "kiosk.done": "All set!",
        "kiosk.doneSub": "Enjoy your meal",
        "kiosk.restart": "Restarting…",
        "kiosk.myCart": "My order",
        "kiosk.pay": "Confirm & pay",
        "kiosk.cancel": "Cancel",
        "kiosk.selectCafeteria": "Select the cafeteria",
        "kiosk.startOver": "Start over",
        "status.pending": "Pending", "status.confirmed": "Confirmed", "status.rejected": "Rejected",
        "status.refunded": "Refunded", "status.online": "Online", "status.offline": "Offline", "status.low_stock": "Low stock",
    },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLangState] = useState(localStorage.getItem("bio_lang") || "es");
    const setLang = useCallback((l) => {
        localStorage.setItem("bio_lang", l);
        setLangState(l);
    }, []);
    const t = useCallback((key) => DICT[lang]?.[key] ?? DICT.es[key] ?? key, [lang]);
    return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
    return useContext(LangContext) || { lang: "es", setLang: () => {}, t: (k) => DICT.es[k] ?? k };
}
